import { useState, useLayoutEffect } from 'react';

const MEDIA_QUERY_BREAKPOINT_MOBILE_SMALL = 'mobile-small';
const MEDIA_QUERY_BREAKPOINT_MOBILE = 'mobile';
const MEDIA_QUERY_BREAKPOINT_IPAD_MINI = 'ipad-mini';
const MEDIA_QUERY_BREAKPOINT_DESKTOP = 'desktop';
const MEDIA_QUERY_BREAKPOINT_DESKTOP_LARGE = 'desktop-large';

const mediaQueryBreakpointList = [
    MEDIA_QUERY_BREAKPOINT_MOBILE_SMALL,
    MEDIA_QUERY_BREAKPOINT_MOBILE,
    MEDIA_QUERY_BREAKPOINT_IPAD_MINI,
    MEDIA_QUERY_BREAKPOINT_DESKTOP,
    MEDIA_QUERY_BREAKPOINT_DESKTOP_LARGE,
];
const breakpointConfigMap = {
    [MEDIA_QUERY_BREAKPOINT_MOBILE_SMALL]: {
        mediaQuery: {
            minWidth: 0,
            maxWidth: 374,
        },
        breakpoints: mediaQueryBreakpointList,
    },
    [MEDIA_QUERY_BREAKPOINT_MOBILE]: {
        mediaQuery: {
            minWidth: 375,
            maxWidth: 743,
        },
        breakpoints: mediaQueryBreakpointList.slice(1),
    },
    [MEDIA_QUERY_BREAKPOINT_IPAD_MINI]: {
        mediaQuery: {
            minWidth: 744,
            maxWidth: 991,
        },
        breakpoints: mediaQueryBreakpointList.slice(2),
    },
    [MEDIA_QUERY_BREAKPOINT_DESKTOP]: {
        mediaQuery: {
            minWidth: 992,
            maxWidth: 1139,
        },
        breakpoints: mediaQueryBreakpointList.slice(3),
    },
    [MEDIA_QUERY_BREAKPOINT_DESKTOP_LARGE]: {
        mediaQuery: {
            minWidth: 1140,
        },
        breakpoints: mediaQueryBreakpointList.slice(4),
    },
};

const createIsOneOfBreakpointsOptions = (breakpoint) => {
    const { [breakpoint]: { breakpoints, }, } = breakpointConfigMap;
    return {
        breakpoints,
        exactMatch: breakpoint,
    };
};

const useScreenDetect = () => {
    const [breakpoint, setBreakpoint] = useState();
    const isOneOfBreakpoints = ({ breakpoints: testBreakpointList, exactMatch, }) => ({ isExact = false, } = {}) => {
        if (typeof breakpoint !== 'string' || !testBreakpointList.length) {
            return false;
        }
        return isExact
            ? breakpoint === exactMatch
            : testBreakpointList.includes(breakpoint);
    };
    useLayoutEffect(() => {
        const { matchMedia } = window;
        const mediaQueryListCleanUpList = [];
        for (const mediaQueryBreakpoint of mediaQueryBreakpointList) {
            const { [mediaQueryBreakpoint]: { mediaQuery: { minWidth, maxWidth, }, }, } = breakpointConfigMap;
            const maxWidthQuery = typeof maxWidth === 'number'
                ? `(max-width: ${maxWidth}px)`
                : '';
            const minWidthQuery = `(min-width: ${minWidth}px)`;
            const mediaQueryList = matchMedia([
                'only screen',
                maxWidthQuery,
                minWidthQuery,
            ].filter(value => !!value)
                .join(' and '));
            const { matches } = mediaQueryList;
            if (matches) {
                setBreakpoint(mediaQueryBreakpoint);
            }
            const onMediaQueryListChange = (event) => {
                const { matches: eventMatches } = event;
                if (!eventMatches) {
                    return;
                }
                setBreakpoint(mediaQueryBreakpoint);
            };
            mediaQueryList.addEventListener('change', onMediaQueryListChange);
            mediaQueryListCleanUpList.push(() => {
                mediaQueryList.removeEventListener('change', onMediaQueryListChange);
            });
        }
        return () => {
            for (const mediaQueryListChangeCleanUp of mediaQueryListCleanUpList) {
                mediaQueryListChangeCleanUp();
            }
        };
    }, [breakpoint]);
    return {
        isMobileSmall: isOneOfBreakpoints(createIsOneOfBreakpointsOptions(MEDIA_QUERY_BREAKPOINT_MOBILE_SMALL)),
        isMobile: isOneOfBreakpoints(createIsOneOfBreakpointsOptions(MEDIA_QUERY_BREAKPOINT_MOBILE)),
        isIpadMini: isOneOfBreakpoints(createIsOneOfBreakpointsOptions(MEDIA_QUERY_BREAKPOINT_IPAD_MINI)),
        isDesktop: isOneOfBreakpoints(createIsOneOfBreakpointsOptions(MEDIA_QUERY_BREAKPOINT_DESKTOP)),
        isDesktopLarge: isOneOfBreakpoints(createIsOneOfBreakpointsOptions(MEDIA_QUERY_BREAKPOINT_DESKTOP_LARGE)),
    };
};

export { MEDIA_QUERY_BREAKPOINT_DESKTOP as M, MEDIA_QUERY_BREAKPOINT_DESKTOP_LARGE as a, MEDIA_QUERY_BREAKPOINT_IPAD_MINI as b, MEDIA_QUERY_BREAKPOINT_MOBILE as c, MEDIA_QUERY_BREAKPOINT_MOBILE_SMALL as d, useScreenDetect as u };
//# sourceMappingURL=hook-ACQF6S6h.js.map
